import { render, staticRenderFns } from "./wachtwoord-wijzigen.html?vue&type=template&id=9ed96dae&scoped=true&"
import script from "./wachtwoord-wijzigen.js?vue&type=script&lang=js&"
export * from "./wachtwoord-wijzigen.js?vue&type=script&lang=js&"
import style0 from "./wachtwoord-wijzigen.css?vue&type=style&index=0&id=9ed96dae&scoped=true&lang=css&"
import style1 from "@/css/appschoolware.css?vue&type=style&index=1&id=9ed96dae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ed96dae",
  null
  
)

export default component.exports